const AccumulationType = {
    leg: 0,
    sinceStart: 1
};

export default AccumulationType;